import { useCallback, useState } from 'react';

import { factoryService } from '../../services/factoryService';
import { AuthImage } from './AuthImage';

type Props = {
  batchId: string;
  unitId: string;
  imgPath?: string;
  pageIdx?: number;
  bbox?: [number, number, number, number];
  alt?: string;
};

/** Prefer MinerU cropped asset (A); fall back to PDF bbox crop (B). */
export function ItemPreviewImage({
  batchId,
  unitId,
  imgPath,
  pageIdx = 0,
  bbox,
  alt = '附图',
}: Props) {
  const [useCrop, setUseCrop] = useState(!imgPath);
  const assetUrl =
    imgPath && !useCrop ? factoryService.layoutUnitAssetUrl(batchId, unitId, imgPath) : '';
  const cropUrl =
    bbox && bbox.length >= 4
      ? factoryService.layoutUnitCropUrl(batchId, unitId, pageIdx, bbox)
      : '';

  const onAssetError = useCallback(() => {
    if (bbox && bbox.length >= 4) setUseCrop(true);
  }, [bbox]);

  const url = useCrop ? cropUrl : assetUrl;
  if (!url) {
    return <div className="compare-item-image-empty">（无图）</div>;
  }

  return (
    <div className="compare-item-image">
      <AuthImage
        key={url}
        url={url}
        alt={alt}
        className="compare-item-image-el"
        onError={useCrop ? undefined : onAssetError}
      />
    </div>
  );
}
